const mapColors = colors => {
  const result = [];
  for (const color of colors) {
    const {
      rgb
    } = color;
    if (typeof (rgb == null ? void 0 : rgb.r) === 'number' && typeof (rgb == null ? void 0 : rgb.g) === 'number' && typeof (rgb == null ? void 0 : rgb.b) === 'number') {
      result.push({
        r: rgb.r,
        g: rgb.g,
        b: rgb.b
      });
    }
  }
  return result;
};
const mapPictureFileInput = file => {
  var _file$media, _file$media2, _file$media3, _file$media4, _file$media5;
  const labels = (file.labels || []).map(description => ({
    description,
    score: 0 // no score in platformized response
  }));
  const faces = (((_file$media = file.media) == null || (_file$media = _file$media.image) == null ? void 0 : _file$media.faces) || []).map(face => ({
    confidence: face.confidence || 0,
    height: face.height || 0,
    width: face.width || 0,
    x: face.x || 0,
    y: face.y || 0
  }));
  const animated = Boolean(file == null || (_file$media2 = file.media) == null || (_file$media2 = _file$media2.image) == null ? void 0 : _file$media2.animated);
  const text_in_image = Boolean(file == null || (_file$media3 = file.media) == null || (_file$media3 = _file$media3.image) == null ? void 0 : _file$media3.containsText);
  const prominent = file == null || (_file$media4 = file.media) == null || (_file$media4 = _file$media4.image) == null || (_file$media4 = _file$media4.colors) == null ? void 0 : _file$media4.prominent;
  const palette = file == null || (_file$media5 = file.media) == null || (_file$media5 = _file$media5.image) == null || (_file$media5 = _file$media5.colors) == null ? void 0 : _file$media5.palette;
  const color_palette = palette ? mapColors(palette) : undefined;
  const prominent_color = prominent ? mapColors([prominent]) : undefined;
  return {
    label: labels,
    face: faces,
    color_palette,
    prominent_color,
    animated,
    text_in_image,
    explicit_content: [] // no explicit content field in platformized response
  };
};
export const mapBasePicture = (file, baseFile) => {
  var _file$media6, _file$media7;
  return {
    ...baseFile,
    fileInput: mapPictureFileInput(file),
    height: ((_file$media6 = file.media) == null || (_file$media6 = _file$media6.image) == null || (_file$media6 = _file$media6.image) == null ? void 0 : _file$media6.height) || 0,
    videoPreviewUrls: null,
    width: ((_file$media7 = file.media) == null || (_file$media7 = _file$media7.image) == null || (_file$media7 = _file$media7.image) == null ? void 0 : _file$media7.width) || 0
  };
};
export const mapUrlToPreview = function (url, operationStatus, previewImage) {
  if (operationStatus === void 0) {
    operationStatus = 'READY';
  }
  const match = url.match(/\/(media\/(.*))/);
  const relativeUrl = match ? match[1] : '';
  const name = match ? match[2] : '';
  return {
    preview: [{
      height: (previewImage == null ? void 0 : previewImage.height) || 0,
      key: (previewImage == null ? void 0 : previewImage.id) || '',
      name,
      secure: false,
      status: operationStatus || 'READY',
      url: relativeUrl,
      width: (previewImage == null ? void 0 : previewImage.width) || 0
    }]
  };
};
export const mapPreviewPictureFromThumbnail = file => {
  const {
    thumbnailUrl
  } = file;
  if (!thumbnailUrl) {
    return {
      preview: []
    };
  }
  return mapUrlToPreview(thumbnailUrl, file.operationStatus);
};
//# sourceMappingURL=BasePicture.mappers.js.map